import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isLoading?: boolean;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-brand-gold hover:bg-yellow-500 text-brand-dark shadow-lg hover:shadow-xl focus:ring-brand-gold',
    secondary: 'bg-brand-dark hover:bg-green-900 text-white shadow-md focus:ring-brand-dark',
    outline: 'border-2 border-brand-dark text-brand-dark hover:bg-brand-dark hover:text-white focus:ring-brand-dark',
    ghost: 'text-brand-dark hover:bg-brand-light hover:text-brand-dark'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClass = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  if (href) {
    const handleClick = () => {
      if (href.includes('betterbysteps.com/cart') && typeof (window as any).fbq === 'function') {
        ;
        (window as any).fbq('track', 'AddToCart');
      }
    };
    return <a href={href} target="_blank" rel="noopener noreferrer" className={combinedClass} onClick={handleClick} data-id="element-300">
        {isLoading && <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-301" />}
        {children}
      </a>;
  }
  return <button className={combinedClass} disabled={disabled || isLoading} {...props} data-id="element-302">
      {isLoading && <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-303" />}
      {children}
    </button>;
}